// An actor as Add Actors gives it and a job takes it (a8's `ActorSource`, G8-talking-head): a
// global or team actor, or a library image (live's Creatives and Manual Uploads).
import type { ActorSource, AiActor, Asset } from "../../api/generated/model";
import { pictureOf } from "../media/ImagePicker";

export interface PickedActor {
  /** Unique across the sources: an actor's or an image's id, with its kind. */
  key: string;
  name: string;
  /** Its portrait; none for an image whose file has no picture yet. */
  imageUrl: string | null;
  /** A lighter picture of it for a tile: the actor's 512 px portrait or the image's thumbnail
   *  (issue 828, item 12); none while it is not made. */
  thumbUrl: string | null;
  /** Its portrait at screen size, the lightbox's poster over its video (issue 910); none for an
   *  image, or a team actor's while it is not made. */
  screenUrl: string | null;
  /** Its own voice: a global actor's, live's recommended one; none for the rest. */
  voice: { id: string; name: string } | null;
  /** Its preview video, for live's eye: a global actor's; none for the rest. */
  videoUrl: string | null;
  /** What a job sends for it. */
  source: ActorSource;
}

export function pickedOfActor(actor: AiActor): PickedActor {
  const global = actor.kind === "global";
  return {
    key: `${global ? "global_actor" : "actor"}:${actor.id}`,
    name: actor.name,
    imageUrl: actor.image_url,
    thumbUrl: actor.thumb_url ?? null,
    screenUrl: actor.screen_url ?? null,
    voice:
      actor.voice_id === null || actor.voice_name === null
        ? null
        : { id: actor.voice_id, name: actor.voice_name },
    videoUrl: actor.video_url,
    source: { kind: global ? "global_actor" : "actor", actor_id: actor.id },
  };
}

export function pickedOfAsset(asset: Asset): PickedActor {
  return {
    key: `asset:${asset.id}`,
    name: asset.name,
    imageUrl: pictureOf(asset),
    thumbUrl: asset.urls.thumb,
    screenUrl: null,
    voice: null,
    videoUrl: null,
    source: { kind: "asset", asset_id: asset.id },
  };
}
